import React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Header from '@components/header/Header'
import ManifestationsHomeSection from './ManifestationsHomeSection'

import * as SiteStore from '@store/site/site'
import * as AuthStore from '@store/auth/auth'
import { store } from '@utils/useSiteChangeHandler'

import useBreakpoint from '@utils/useBreakpoints'
import useI18n from '@i18n/useI18n'
import useReducer from '@store/useReducer'

import { AuthScope } from '@api/enum'
import api from '@api/api'

type Props = {
  status: Status
  onBack?: () => void
}

const MyManifestationsScreen = ({ status, onBack }: Props) => {
  const i18n = useI18n()
  const [, bp] = useBreakpoint()
  const isPhone = bp === 'phone'

  const scopes = useReducer(AuthStore.store, (s) => s.scopes)
  const dataStatus = useReducer(store, (s) => s.status)

  const onManifestationSelected = (manifestation: ManifestationResponse) => {
    SiteStore.actions.setManifestation(manifestation)
    api.site.get(manifestation.siteId).then(SiteStore.actions.setSite)
  }

  const headerButtons = scopes.includes(AuthScope.HomePersonaExposant)
    ? [
        {
          label: i18n.t('screens.site.changeSite'),
          onClick: () => SiteStore.actions.resetSite(),
        },
      ]
    : []

  return (
    <Root
      loading={dataStatus === 'loading' || status === 'loading'}
      header={i18n.t('screens.home.myManifestations')}
      onLeft={onBack}>
      {!isPhone && <Header title={i18n.t('screens.home.myManifestations')} buttons={headerButtons} />}
      <MainContainer>
        <ManifestationsHomeSection
          onManifestationSelected={onManifestationSelected}
          hideSectionTitle
          hideStats
          showNotOpened={!scopes.includes(AuthScope.ManifestationsExposantLecture)}
        />
      </MainContainer>
    </Root>
  )
}

const MainContainer = styled(View)`
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? '24px 16px' : '24px')};
`
export default MyManifestationsScreen
